import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { Twitter, Facebook, Instagram, YouTube, Room, Contacts, Schedule } from '@material-ui/icons';

import logo from '../../../assets/images/pmag.png';

import './styles.css';

export default function Footer() {
  return (
    <footer className="no-print">
      <div className="container">
        <div className="left">
          <img src={logo} alt="Prefeitura de Aparecida" height='80'/>
          <div className="social-media">
            <Tooltip title="Twitter">
              <IconButton aria-label="twitter" href="https://twitter.com/prefaparecida" target="_blank">
                <Twitter />
              </IconButton>
            </Tooltip>
            <Tooltip title="Facebook" href="https://fb.com/PrefAparecida" target="_blank">
              <IconButton aria-label="facebook">
                <Facebook />
              </IconButton>
            </Tooltip>
            <Tooltip title="Youtube" href="https://youtube.com/user/prefeituraaparecida" target="_blank">
              <IconButton aria-label="youtube">
                <YouTube />
              </IconButton>
            </Tooltip>
            <Tooltip title="Instagram" href="https://instagram.com/prefaparecida" target="_blank">
              <IconButton aria-label="instagram">
                <Instagram />
              </IconButton>
            </Tooltip>
          </div>
        </div>
        <div className="right">
          <span>Secretaria Municipal de Meio Ambiente</span>
          <span><Room className="icon"/>&nbsp;&nbsp;Rua João Batista de Toledo, Qd. 16, Lt. Área, Centro, Aparecida de Goiânia</span>
          <span><Contacts className="icon"/>&nbsp;&nbsp;Fones:&nbsp; <a href="tel:+556235455849">(62) 3545-5849</a>&nbsp;/&nbsp;<a href="tel:+556235455955">(62) 3545-5955</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Email: &nbsp;<a href="mailto:semmaapg@hotmail.com">semmaapg@hotmail.com</a></span>
          <span><Schedule className="icon"/>&nbsp;&nbsp;08h às 11h30 - 13h às 17h30</span>
        </div>
      </div>
      <div className="footer-bottom">
        <span>Diretoria de Tecnologia da Informação</span>
        <span>Secretaria de Ciência, Tecnologia e Inovação</span>
      </div>
    </footer>
  )
}
